/**
 * GLSL to generate a texture containing object IDs, used for GPU accelerated picking.
 * @module
 */
import {
  isolateModeDeclarationsFragment,
  isolateModeDeclarationsVertex,
  isolateModeFragment,
  isolateModeVertex,
} from "./entityIdHighlight";

export const pickingVertexShader = `
varying vec4 vId;

#include <clipping_planes_pars_vertex>

${isolateModeDeclarationsVertex}

void main() {
  vId = id;
	#include <begin_vertex>
	#include <project_vertex>
  ${isolateModeVertex}
#if defined(ISOLATE_MODE) && ISOLATE_MODE == 1
  vIsolateDiscard += 1.0 - vId.a; // If the id alpha value is zero, it means that the object is skipped for picking purposes.
#endif
  // TODO: We could also include support for morph targets and skinning in case we ever need them.
  #include <clipping_planes_vertex>
}
`;

export const pickingFragmentShader = `
varying vec4 vId;

#include <clipping_planes_pars_fragment>

${isolateModeDeclarationsFragment}

void main() {
	#include <clipping_planes_fragment>

  ${isolateModeFragment}

  gl_FragColor = vId;
}
`;
